export default {
  name: '移动',
  buttons: [
    {
      title: '移动工具',
      key: '[空格 / 按下滚轮拖动]'
    }
  ]
}
